import { FilterOperator, FilterOperators } from "../../types";

// // // //

/**
 * isAndOrOperator
 * Determines whether a given filter operator is an "AND" or "OR" operator.
 * @param {FilterOperator} operator - The filter operator to check.
 * @returns {boolean} - true if the operator is an "AND" or "OR" operator, false otherwise.
 */
export function isAndOrOperator(operator: FilterOperator): boolean {
    return [FilterOperators.And, FilterOperators.Or].includes(
        operator as FilterOperators,
    );
}
